import { es_i18n } from "./es/es.js";
import { en_i18n } from "./en/en.js";
import { ar_i18n } from "./ar/ar.js";
import { it_i18n } from "./it/it.js";
import { pt_i18n } from "./pt/pt.js";
import { fr_i18n } from "./fr/fr.js";
import { de_i18n } from "./de/de.js";
import { pl_i18n } from "./pl/pl.js";

export const translations = {
    es: es_i18n,
    en: en_i18n,
    ar: ar_i18n,
    it: it_i18n,
    pt: pt_i18n,
    fr: fr_i18n,
    de: de_i18n,
    pl: pl_i18n,
};
